export default class Util {
    // Retorna el que hi ha a str entre str1 i str2 tenint en compte majúscules/minúscules començant des de pos (per llegir facilment coses d'un XML)
    // pos és un objecte que té el camp pos o que retorna la posició on ha acabat.
    public static getBetween(str1: string, str2: string, str: string, pos?: {pos: number}): string {
        if (str != null) {
            let i = 0;
            if (pos && pos.pos > 0) {
                i = str.indexOf(str1, pos.pos);
            } else {
                i = str.indexOf(str1);
            }
            if (i >= 0 && i + str1.length < str.length) {
                i += str1.length;
                const j = str.indexOf(str2, i);
                if (j > i) {
                    if (pos) {
                        pos.pos = j + str2.length;
                    }
                    return str.substring(i, j);
                }
            }
        }
        if (pos) {
            pos.pos = str.length;
        }
        return '';
    }
    
    // Retorna el que hi ha a str entre str1 i str2 sense tenir en compte majúscules/minúscules començant des de pos (per llegir facilment coses d'un XML)
    // pos és un objecte que té el camp pos o que retorna la posició on ha acabat.
    public static getBetweenI(str1: string, str2: string, str: string, pos?: {pos: number}): string {
        if (str != null) {
            const istr = str.toLowerCase();
            const istr1 = str1.toLowerCase();
            const istr2 = str2.toLowerCase();
            let i = 0;
            if (pos && pos.pos > 0) {
                i = istr.indexOf(istr1, pos.pos);
            } else {
                i = istr.indexOf(istr1);
            }
            if (i >= 0 && i + istr1.length < istr.length) {
                i += istr1.length;
                const j = istr.indexOf(istr2, i);
                if (j > i) {
                    if (pos) {
                        pos.pos = j + istr2.length;
                    }
                    return str.substring(i, j);
                }
            }
        }
        if (pos) {
            pos.pos = str.length;
        }
        return '';
    }
    
    // Fa un replaceAll
    public static replaceAll(str: string, find:string , replace: string): string {
        return str.replace(new RegExp(Util.escapeRegExp(find), 'g'), replace);
    }

    // Escapa una expressió regular
    public static escapeRegExp(str: string): string {
        return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
    }

    // Escapa un XML.
    public static escapeXML(str: string): string {
        str = str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
        return str;
    }

    // Desescapa un XML.
    public static unescapeXML(str: string): string {
        str = str.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, '\'').replace(/&amp;/g, '&');
        return str;
    }

    // Codifica caràcters HTML 
    public static encodeHTML(str: string): string {
        return str.replace(/[\u00A0-\u9999<>&](?!#)/gim, function(i) {
          return '&#' + i.charCodeAt(0) + ';';
        });
    }
    
    // Decodifica caracters html
    public static decodeHTML(str: string): string {
        return str.replace(/&#([0-9]{1,3});/gi, function(match, num) {
            return String.fromCharCode(parseInt(num));
        });
    }

    // Construeix el Request
    public static getXMLRequest(funcName: string, paramNames: string[], paramValues: string[]): string {
        let xreq: string = '<?xml version="1.0" encoding="utf-8"?><soap12:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap12="http://www.w3.org/2003/05/soap-envelope"><soap12:Body><' +
                           funcName + 
                           ' xmlns="http://www.ajmanresa.cat/WSSig"><pXML>';
        let prms = '';
        let i: number;
        for (i = 0; i < paramNames.length; i++) {
            if (paramValues[i]) {
                prms += '<' + paramNames[i] + '>' + paramValues[i] + '</' + paramNames[i] + '>';
            } else {
                prms += '<' + paramNames[i] + ' />';
            }
        }
        xreq += this.escapeXML('<WSParam>' + prms + '</WSParam>');
        xreq += '</pXML></'+ funcName + '></soap12:Body></soap12:Envelope>';
        return xreq;
    }

    // Retorna la resposta del resultat d'un XMLRequest
    public static getXMLResponse(funcName: string, result: string): string {
        let xresp: string = this.getBetween('<' + funcName + 'Result>', '</' + funcName + 'Result>', result, { pos: 0 });
        if (xresp) {
            xresp = this.unescapeXML(xresp);
        }
        return xresp;
    }

    // Retorna l'error contingut en una resposta tipus <WSResp> 
    // Si no hi ha error retorna un string en blanc ''
    // Si hi ha error retorna 'N - Msg'
    public static getXMLError(xresp: string): string {
        const err = Util.getBetween('<WSError>', '</WSError>', xresp, { pos: 0 });
        const errCode = Util.getBetween('<ErrCode>', '</ErrCode>', err, { pos: 0 });
        const errMsg = Util.getBetween('<ErrMsg>', '</ErrMsg>', err, { pos: 0 });
        if ((!errCode || errCode === "0") && ! errMsg) {
            return '';
        } else {
            return errCode + ' - ' + errMsg
        }
    }

    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    public static getParamString(obj: object, existingUrl?: string, uppercase?: boolean) {
        const params: Array<string> = [];
        for (const i in obj) {
            params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
        }
        return ((!existingUrl || existingUrl.indexOf('?') === -1) ? '?' : '&') + params.join('&');
    }

    // Retorna true si un valor és null o indefinit
    public static isNullOrUndefined(val: object): boolean {
        return (val === null || val === undefined);
    }

    // Fa el parse d'un booleà (true o false)
    public static parseBoolean(str: string): boolean {
        return (!!str && str.trim().toLowerCase() === 'true');
    }

    // Fa el padding d'un número com a string amb zeros al davant
    public static pad(val: string, len: number): string {
        while (val.length < len) {
            val = '0' + val;
        }
        return val;
    }

    // Retorna la data d'avui correctament formatada (yyyymmdd)
    public static getDataYYYYMMDD(): string {
        const dt = new Date();
        const dd: string = Util.pad(dt.getDate().toString(), 2);
        const mm: string = Util.pad((dt.getMonth() + 1).toString(), 2);
        const yyyy = String(dt.getFullYear());
        return yyyy + mm + dd;
    }

    // Passa una data de yyyymmdd a dd/mm/aaaa
    public static formatDate(pdate: string): string {
        return pdate.substring(8, 10) + '/' + pdate.substring(5, 7) + '/' + pdate.substring(0, 4);
    }

}